import { withRouter } from 'react-router-dom'

import { createSink } from 'recompose'

import { FlowRoute } from 'utils/FlowProvider/types'

import { UnknownRoute, sendToSentry } from './errors'

const pageTitleMap = new Map<string, string>([
  [FlowRoute.Signup, 'Sign Up'],
  [FlowRoute.Analyzing, 'Analyzing'],
  [FlowRoute.BankLinkSuccess, 'Bank Account Linked'],
  [FlowRoute.ChooseFundingSource, 'Choose Funding Source'],
  [FlowRoute.ContactInfo, 'Contact Info'],
  [FlowRoute.Funding, 'Add an account'],
  [FlowRoute.Institutions, 'Select your financial institution'],
  [FlowRoute.DirectBankIntegration, 'Link your financial institution'],
  [FlowRoute.InvestInterstitial, 'Set up your Invest account'],
  [FlowRoute.InvestorQuestions, 'More About You'],
  [FlowRoute.LaterIraRecommendation, 'Later IRA recommendation'],
  [FlowRoute.LaterOnboardingQuestions, 'Later Onboarding Questions'],
  [FlowRoute.LaterSuitabilityQuestions, 'Later Suitability Questions'],
  [FlowRoute.ManualFundingSource, 'Manual Funding Source'],
  [FlowRoute.MOCProgressStepOne, 'Mighty Oak Card'],
  [FlowRoute.MOCProgressStepTwo, 'Mighty Oak Card'],
  [FlowRoute.MOCProgressStepThree, 'Mighty Oak Card'],
  [FlowRoute.OneTimeInvestment, 'One-Time Investment'],
  [FlowRoute.PersonalInfo, 'Personal Info'],
  [FlowRoute.Portfolio, 'Get Recommendations'],
  [FlowRoute.PortfolioOverview, 'Portfolio Overview'],
  [FlowRoute.SelectPortfolioTheme, 'Select Portfolio Theme'],
  [FlowRoute.PreviewPortfolio, 'Portfolio Preview'],
  [FlowRoute.ESGEducationFlow, 'ESG Education Tour'],
  [FlowRoute.RecurringInvestment, 'Recurring Investment'],
  [FlowRoute.ReferralDisclosure, 'Referral Disclosure'],
  [FlowRoute.ReferralReward, 'Referral Reward'],
  [FlowRoute.RoundUpsFunding, 'Link your accounts for Round-Ups'],
  [FlowRoute.RoundUpsInterstitial, 'Round-Ups® are on'],
  [FlowRoute.RoundUpsPast, 'We have found past Round-Ups'],
  [FlowRoute.RoundUpsSetup, 'Set automatic or manual Round-Ups'],
  [FlowRoute.SecondChanceBankLink, 'Second Chance Bank Link'],
  [FlowRoute.SelectTier, 'Select Tier'],
  [FlowRoute.SSN, 'Social Security Number'],
  [FlowRoute.Success, 'Success! Registration Complete'],
  [FlowRoute.SuitabilityInterstitial, 'Get Your Recommendations'],
  [FlowRoute.SuitabilityQuestions, 'Suitability Questions'],
  [FlowRoute.PortfolioRecommendation, 'Portfolio Recommendation'],
  [FlowRoute.Welcome, 'Welcome'],
  [FlowRoute.SignYourCard, 'Sign Your Card'],
  [FlowRoute.Prefund, 'Prefund Your Card'],
  [FlowRoute.SpendOrderConfirmation, 'Confirm Your Order'],
  [FlowRoute.SpendCoreInterstitial, 'Open Investment Account'],
  [FlowRoute.PricingInterstitial, 'View your plan'],
])

// Object used to match different flow welcome screens
const welcomeTitle = {
  laterOnboarding: 'Later Onboarding Welcome',
}

export const setPageTitle = ({ location }) => {
  const defaultPageTitle = 'Acorns'
  const flowParam = new URLSearchParams(location.search).get('flow')

  try {
    const pathname = location.pathname.toLowerCase()
    if (pageTitleMap.has(pathname) || flowParam) {
      document.title =
        (pathname !== FlowRoute.Welcome
          ? pageTitleMap.get(pathname)
          : welcomeTitle[flowParam] || 'Welcome') + ' - Acorns'
    } else if (process.env.BUILD_ENV !== 'production') {
      sendToSentry(new UnknownRoute('Unable to set page title.'), { extras: { pathname } })
      document.title = defaultPageTitle
    }
  } catch (error) {
    sendToSentry(error)
  }
}

export default withRouter(createSink(setPageTitle))
